import { jsx } from "react/jsx-runtime";
import { ChatBubble } from "@pcln/horizon";
import { Box } from "pcln-design-system";
import { useContext, useMemo } from "react";
import styled_components from "styled-components";
import { VoteType } from "./chatTypes.js";
import { ChatMessage } from "./components/CustomChatMessage/index.js";
import { CustomMarkdown } from "./components/MarkdownComponent/CustomMarkdown.js";
import { MessageFooterWithVote } from "./components/MessageFooter/MessageFooterWithVote.js";
import { ROLE_ASSISTANT } from "./constants/misc.js";
import { GREETING_MESSAGE } from "./constants/prompt.js";
import { ChatbotDataContext } from "./context/ChatbotDataContext.js";
import { useMessageFeedback } from "./hooks/useMessageFeedback.js";
import { useSafeDateString } from "./hooks/useSafeDateString.js";
import { TravelBotLogoImage } from "./TravelBotLogoImage.js";
import { sanitizeText } from "./utils/sanitizeText.js";
const ChatMessageWrapper = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "TravelBotChatSingleDialogGeneric__ChatMessageWrapper"
})([
    "p{margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;margin-bottom:8px;font-size:",
    "px;}p:last-child{margin-bottom:0;}strong{font-weight:bold;}"
], (props)=>props.theme.fontSizes[props.fontSize]);
const TravelBotChatSingleDialogGeneric = (props)=>{
    const { isMobile, fullStreamingTexts, setiValues } = useContext(ChatbotDataContext);
    const { message, isLastMessage } = props;
    const { content, role, date } = message;
    const isAssistant = role === ROLE_ASSISTANT;
    const isStreaming = isAssistant && isLastMessage && fullStreamingTexts.length > 0;
    const sanitizedText = useMemo(()=>sanitizeText(content), [
        content
    ]);
    const { submitFeedback } = useMessageFeedback(message);
    const MessageIcon = useMemo(()=>{
        if (isAssistant) return ()=>/*#__PURE__*/ jsx(TravelBotLogoImage, {});
        return ()=>null;
    }, [
        isAssistant
    ]);
    const footerMessagePrefix = isAssistant ? 'Penny' : '';
    const messageContent = /*#__PURE__*/ jsx(ChatMessageWrapper, {
        fontSize: 2,
        children: /*#__PURE__*/ jsx(CustomMarkdown, {
            isStreaming: isStreaming,
            children: sanitizedText
        })
    });
    const dateString = useSafeDateString(date);
    return setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(ChatBubble, {
        role: isAssistant ? 'response' : 'user',
        showResponseIcon: isAssistant,
        showVote: isAssistant && content !== GREETING_MESSAGE,
        canToggleVote: false,
        dateString: dateString,
        onIconClick: {
            thumbsUp: ()=>submitFeedback(VoteType.UP),
            thumbsDown: ()=>submitFeedback(VoteType.DOWN)
        },
        slots: {
            wrapperSlot: 'pb-1',
            containerSlot: '',
            contentSlot: '',
            responseIconSlot: '',
            footerSlot: ''
        },
        children: messageContent
    }) : /*#__PURE__*/ jsx(ChatMessage, {
        "data-testid": isAssistant ? 'pennyCCM' : 'userCCM',
        mb: isAssistant ? '40px' : 3,
        ml: isAssistant ? '' : 'auto',
        variation: isAssistant ? 'initial' : 'outgoing',
        Icon: MessageIcon,
        message: messageContent,
        footer: /*#__PURE__*/ jsx(MessageFooterWithVote, {
            footerMessagePrefix: footerMessagePrefix,
            isNotUser: isAssistant,
            isGreetingMessage: GREETING_MESSAGE === content,
            isMobile: isMobile,
            message: message
        })
    });
};
export { TravelBotChatSingleDialogGeneric };
